import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('yelp'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.yelp,
  logoPath: logos.yelp
});
